module.exports = __webpack_public_path__ + "static/media/gym_02.39664019.png";